import React from 'react';

import useScreen from 'hooks/useScreen';
import PDPSelectUpholsteryDecideLater from '../PDPSelectUpholstery/PDPSelectUpholsteryDecideLater';

const PDPDecideLaterOverlay = () => {
  const { isMobile } = useScreen();

  return (
    <div className="items-center bg-[hsla(0,0%,100%,.5)] flex h-full justify-center left-0 pointer-events-none absolute top-0 w-full z-[3]">
      <div className="text-sm font-bold bg-white rounded-sm text-gray px-6 py-3.5 lg:text-base lg:font-bold lg:px-4 lg:py-3.5 !bg-gray-light8/70">
        {isMobile ? <PDPSelectUpholsteryDecideLater /> : 'Decide Later'}
      </div>
    </div>
  );
};

export default PDPDecideLaterOverlay;
